import settings from '@/settings'

let insert = (versao, headers) => {
  return fetch(`${settings.apetrusApi}/versionamento/insert/`, {
    method: 'POST',
    body: JSON.stringify(versao),
    mode: 'cors',
    headers: headers
  })
}

let get = (page, headers) => {
  return fetch(`${settings.apetrusApi}/versionamento/paginated/?page=${page}`, {
    method: 'GET',
    mode: 'cors',
    headers: headers
  })
}

let update = (id, data, headers) => {
  return fetch(`${settings.apetrusApi}/versionamento/update/?id_versao=${id}`, {
    method: 'PUT',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

let deleteVersion = (id, headers) => {
  return fetch(`${settings.apetrusApi}/versionamento/delete/?id_versao=${id}`, {
    method: 'DELETE',
    mode: 'cors',
    headers: headers
  })
}

export default {
  insert,
  get,
  update,
  deleteVersion
}
